import { arMessages } from "./ar"
import { azMessages } from "./az"
import { bnMessages } from "./bn"
import { beMessages } from "./be"
import { csMessages } from "./cs"
import { deMessages } from "./de"
import { enMessages } from "./en"
import { esMessages } from "./es"
import { faMessages } from "./fa"
import { frMessages } from "./fr"
import { hiMessages } from "./hi"
import { hyMessages } from "./hy"
import { idMessages } from "./id"
import { itMessages } from "./it"
import { jaMessages } from "./ja"
import { kaMessages } from "./ka"
import { kkMessages } from "./kk"
import { koMessages } from "./ko"
import { kyMessages } from "./ky"
import { msMessages } from "./ms"
import { nlMessages } from "./nl"
import { plMessages } from "./pl"
import { ptBRMessages } from "./pt-BR"
import { roMessages } from "./ro"
import { ruMessages, type MessageKey } from "./ru"
import { svMessages } from "./sv"
import { swMessages } from "./sw"
import { tgMessages } from "./tg"
import { siMessages } from "./si"
import { taMessages } from "./ta"
import { thMessages } from "./th"
import { tlMessages } from "./tl"
import { trMessages } from "./tr"
import { ukMessages } from "./uk"
import { urMessages } from "./ur"
import { uzMessages } from "./uz"
import { viMessages } from "./vi"
import { zhMessages } from "./zh"
import { nonMessages } from "./non"
import { sjnMessages } from "./sjn"
import { naviMessages } from "./art-x-navi"
import { hutteseMessages } from "./art-x-huttese"
import { highValyrianMessages } from "./art-x-hv"
import type { SpecialLocale } from "./specialLocaleTypes"
import { uzbekLatinToCyrillic } from "./uzbekCyrillic"

export type AppLocale =
  | SpecialLocale
  | "az"
  | "bn"
  | "si"
  | "sw"
  | "ta"
  | "en"
  | "ar"
  | "be"
  | "hy"
  | "id"
  | "ms"
  | "hi"
  | "it"
  | "ka"
  | "kk"
  | "ky"
  | "fa"
  | "pt-BR"
  | "ru"
  | "es"
  | "tg"
  | "tl"
  | "tr"
  | "uk"
  | "ur"
  | "uz"
  | "vi"
  | "de"
  | "fr"
  | "ja"
  | "ko"
  | "zh"
  | "pl"
  | "nl"
  | "th"
  | "cs"
  | "sv"
  | "ro"

export const DEFAULT_LOCALE: AppLocale = "ru"

const catalogs: Partial<Record<AppLocale, Record<MessageKey, string>>> = {
  non: nonMessages,
  sjn: sjnMessages,
  "art-x-navi": naviMessages,
  "art-x-huttese": hutteseMessages,
  "art-x-hv": highValyrianMessages,
  ar: arMessages,
  az: azMessages,
  bn: bnMessages,
  be: beMessages,
  cs: csMessages,
  de: deMessages,
  en: enMessages,
  es: esMessages,
  fa: faMessages,
  fr: frMessages,
  hi: hiMessages,
  hy: hyMessages,
  id: idMessages,
  it: itMessages,
  ja: jaMessages,
  ka: kaMessages,
  kk: kkMessages,
  ko: koMessages,
  ky: kyMessages,
  ms: msMessages,
  nl: nlMessages,
  pl: plMessages,
  "pt-BR": ptBRMessages,
  ro: roMessages,
  ru: ruMessages,
  sv: svMessages,
  sw: swMessages,
  tg: tgMessages,
  si: siMessages,
  ta: taMessages,
  th: thMessages,
  tl: tlMessages,
  tr: trMessages,
  uk: ukMessages,
  ur: urMessages,
  uz: uzMessages,
  vi: viMessages,
  zh: zhMessages,
}

export function translate(key: MessageKey, locale: AppLocale = DEFAULT_LOCALE): string {
  const value = catalogs[locale]?.[key] ?? ruMessages[key]
  return locale === "uz" ? uzbekLatinToCyrillic(value) : value
}

// Backward-compatible baseline helper. Existing call sites remain Russian until
// they are intentionally migrated to the reactive locale hook screen by screen.
export function t(key: MessageKey): string {
  return translate(key, DEFAULT_LOCALE)
}

export type { MessageKey }
